import Vue from 'vue'
import Router from 'vue-router'
import ListPaper from '@/home/ListPaper'
import Login from '@/login/Login'
import SingleList from '@/singlelist/SingleList'
import Question from '@/question/Question'
import fh from '@/question/fh'
import Servey from '@/servey/Servey'
import Serback from '@/servey/serback'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/list',
      name: 'ListPaper',
      component: ListPaper
    },
    {
      path: '/single/:id',
      name: 'SingleList',
      component: SingleList
    },
    {
      path: '/qt/:id?',
      name: 'Question',
      component: Question
    },
    {
      path: '/fh',
      name: 'fh',
      component: fh
    },
    {
      path: '/servey/:id?',
      name: 'Servey',
      component: Servey
    },
    {
      path: '/result',
      name: 'result',
      component: Serback
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js